export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Výpočet úspor v aplikaci Walutomat',
    rangeFrom: 'Chci',
    forBuy: 'pro',
    forSell: 'na',
    directionBuy: 'Nákup',
    directionSell: 'Prodej',
    payText: 'zaplatíte',
    sellText: 'obdržíte',
    buySelect: 'koupit',
    sellSelect: 'prodat',
    rateText: 'Směnný kurz',
    amountText: 'Částka',
    includes: 'Včetně',
    commission: '{{commission}}% provize',
    howItWorks: '',
    banksComapreOpen: 'Porovnání s ostatními',
    banksComapreClose: 'Sbalit seznam',
    savingsMonthly: 'S Walutomat ušetříte i jednou',
    savingsYearly: 'nahrazující po celý rok, každý měsíc.',
    conjunction: 'a',
    serverError: 'Chyba komunikace se serverem',
    unsupportedPair: 'V současné době nenabízíme kurzy pro vybraný měnový pár.',
    infoError: {
      exchange: 'Na Walutomat.pl můžete přímo směňovat',
      transactionFee:
        'a zpět. Taková transakce v bance je spojena s vysokým poplatkem, který obvykle dosahuje i 5-10 % směňované částky.',
    },
    spinnerError: {
      generic: 'Při stahování dat došlo k problému',
      toManyRequests:
        'Kalkulačku nyní používá mnoho uživatelů. Zkuste to prosím znovu později nebo kontaktujte Zákaznický servis <a href="https://www.walutomat.com/cs/kontakt/">https://www.walutomat.com/cs/kontakt/</a>.',
    },
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Zkontrolujte kurzy a{{nbsp}}směňte měnu v{{nbsp}}Walutomat – rychle a{{nbsp}}výhodně.',
    actualRate: 'Aktuální kurz',
    buySelect: 'Kupuji',
    sellSelect: 'Prodávám',
    buttonText: 'Vyměnit',
    exchangeAmountSellLabel: 'Získáte',
    exchangeAmountBuyLabel: 'Vložte',
    commission: 'Propagační provize ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Pole nemůže být prázdné',
    requiredField: 'Pole je povinné',
    passwordToShort: 'Heslo musí mít 8 znaků',
    emailNotValid: 'Pole musí obsahovat platnou e-mailovou adresu',
    emailReserved: 'E-mailová adresa je již obsazena',
    rateEmpty: 'Všechna pole musí být vyplněna',
    serverUnknownError: 'Chyba komunikace se serverem',
    invalidCharacters: 'Pole obsahuje neplatné znaky',
    phoneNotValid: 'Telefonní číslo je nesprávné',
    checkBoxBelow: 'Pro odeslání zprávy zaškrtněte políčko níže',
  },
  password: {
    show: 'zobrazit',
    hide: 'skrýt',
  },
  howItWorks: {
    showButton: 'Zobrazit více',
    hideButton: 'Zobrazit méně',
  },
}
